// extracted by mini-css-extract-plugin
module.exports = {"notFoundWrapper":"NotFound_notFoundWrapper__283SL","notFoundContainer":"NotFound_notFoundContainer__2ejdN"};